import * as actionTypes from '../actions/actionTypes'

const initialState = {
  memberInfo: {
    memberInfo: '',
    isLoading: false,
    isError: false
  },
  accountLink: {
    accountLink: '',
    isLoading: false,
    isError: false
  },
  banners: {
    banners: '',
    isLoading: false,
    isError: false
  },
  commPref: {
    commPref: '',
    isLoading: false,
    isError: false
  },
  isLoading: false,
  isError: false
}

const memberReducer = (state = initialState, action = {}) => {
  const newState = { ...state }
  switch (action.type) {
    case actionTypes.FETCH_MEMBER_INFO:
      return { ...newState, memberInfo: { ...newState.memberInfo, isLoading: true } }

    case actionTypes.FETCH_MEMBER_INFO_SUCCESS:
      return { ...newState, memberInfo: { memberInfo: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.FETCH_MEMBER_INFO_FAILURE:
      return { ...newState, memberInfo: { memberInfo: { ...action.payload }, isLoading: false, isError: true } }

    case actionTypes.ADD_ACCOUNT_LINK:
      return { ...newState, accountLink: { ...newState.accountLink, isLoading: true } }

    case actionTypes.ADD_ACCOUNT_LINK_SUCCESS:
      return { ...newState, accountLink: { accountLink: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.ADD_ACCOUNT_LINK_FAILURE:
      return { ...newState, accountLink: { ...newState.accountLink, isLoading: false }, isLoading: false, isError: true }

    case actionTypes.FETCH_BANNERS_LIST:
      return { ...newState, banners: { ...newState.banners, isLoading: true } }

    case actionTypes.FETCH_BANNERS_LIST_SUCCESS:
      return { ...newState, banners: { banners: action.payload, isLoading: false, isError: false } }

    case actionTypes.FETCH_BANNERS_LIST_FAILURE:
      return { ...newState, banners: { ...newState.banners, isLoading: false }, isLoading: false, isError: true }

    case actionTypes.UPDATE_COMM_PREF_RESET:
      return { ...newState, commPref: { ...newState.commPref, isLoading: false, isError: false } }

    case actionTypes.UPDATE_COMM_PREF:
      return { ...newState, commPref: { ...newState.commPref, isLoading: true } }

    case actionTypes.UPDATE_COMM_PREF_SUCCESS :
      return { ...newState, memberInfo: { memberInfo: { ...newState.memberInfo.memberInfo, memberCommPreference: { ...JSON.parse(action.payload.config.data), displayFlag: true } }, isLoading: false, isError: false }, commPref: { commPref: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.UPDATE_COMM_PREF_FAILURE:
      return { ...newState, commPref: { ...newState.commPref, isLoading: false, isError: true, commPref: { ...action.payload } } }

    default:
      return { ...newState }
  }
}

export default memberReducer
